<template>
  <!-- 社区服务人员 -->
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="age" scope="{row}">
        <span>{{ calculateAge(row.birthday) }}</span>
      </template>

      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.communityserviceuser_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/community/service/user/communityserviceuser';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {
        birthday: '',
        age: '',
      },
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        align: 'center',
        searchShow: true,
        searchMenuSpan: 12,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        labelWidth: 120,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '社区',
            prop: 'communityId',
            type: 'select',
            span: 8,
            dicUrl: '/api/v4ward/community/list',
            props: { label: 'name', value: 'id' },
            rules: [
              {
                required: true,
                message: '请输入社区',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '服务人员姓名',
            span: 8,
            maxlength: 10,
            showWordLimit: true,
            prop: 'name',
            rules: [
              {
                required: true,
                message: '请输入服务人员姓名',
                trigger: 'change',
              },
            ],
            search: true,

            searchLabelWidth: 100,
          },
          {
            label: '性别',
            prop: 'sex',
            span: 8,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=sex',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入性别',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出生年月',
            span: 8,
            prop: 'birthday',
            type: 'date',
            hide: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: false,
                message: '请输入出生年月',
                trigger: 'change',
              },
            ],
          },
          {
            label: '年龄',
            span: 8,
            prop: 'age',
            disabled:true,
            slot: true,
            rules: [
              {
                required: false,
                message: '请输入年龄',
                trigger: 'change',
              },
            ],
          },
          {
            label: '联系方式',
            prop: 'phone',
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入联系方式',
                trigger: 'change',
              },
              {
                pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
                message: '请输入正确的联系电话',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '住址',
            prop: 'address',
            maxlength: 10,
            showWordLimit: true,
            span: 8,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入住址',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务类别',
            span: 8,
            prop: 'serviceType',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=community_service_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入服务类别',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务行业',
            span: 8,
            prop: 'serviceIndustry',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=community_service_industry',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入服务行业',
                trigger: 'change',
              },
            ],
          },

          {
            label: '服务区域',
            span: 8,
            prop: 'serviceArea',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=community_service_area',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入服务区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '职责范围介绍',
            prop: 'description',
            type: 'textarea',
            maxlength: 500,
            showWordLimit: true,
            span: 24,
            rules: [
              {
                required: true,
                message: '职责范围介绍',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  watch: {
    'form.birthday'(newDate) {
      this.form.age = this.calculateAge(newDate);
    },
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.communityserviceuser_add, true),
        viewBtn: this.vaildData(this.permission.communityserviceuser_view, true),
        delBtn: this.vaildData(this.permission.communityserviceuser_delete, true),
        editBtn: this.vaildData(this.permission.communityserviceuser_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    //设置表格高度
    ajustView() {
      const tableInitH = this.bodyHeight - 388; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.option.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.option.height == tableInitH) {
              this.option.height = tableInitH + searchH;
            } else {
              this.option.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    calculateAge(birthday) {
      if (birthday) {
        var currentDate = new Date();
        var birthDate = new Date(birthday);
        var age = currentDate.getFullYear() - birthDate.getFullYear();

        if (
          currentDate.getMonth() < birthDate.getMonth() ||
          (currentDate.getMonth() === birthDate.getMonth() &&
            currentDate.getDate() < birthDate.getDate())
        ) {
          age--;
        }
        if (age < 0) {
          age = 0;
        }
        return age;
      }
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      } else {
        this.tool.clearObject(this.form);
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
